import bigPuffImage from '../assest/Legal_Big_Puff_Device_1_200x.jpg';
import prefilledPodKitsImage from '../assest/PodKits_2_200x.jpg';
import nicSaltImage from '../assest/nic-salt-category_200x.jpg';
import freebaseImage from '../assest/New_Complaint_600s.jpg';
import shortfillsImage from '../assest/shortfills-category_200x.jpg';
import podKitsImage from '../assest/VapeKits_2_200x.jpg';
import vapePodsImage from '../assest/pods-category_200x.jpg';
import vapeKitsImage from '../assest/VapeKits_2_200x.jpg';
import coilsTanksImage from '../assest/coils-tanks-category_200x.jpg';
import vapeModsImage from '../assest/mods-category_200x.jpg';
import accessoriesImage from '../assest/Accessoroies_1_200x.jpg';
import posImage from '../assest/Pos_1_200x.jpg';

const categoryItems = [
  { id: 'big-puff', title: 'BIG PUFF DEVICES', image: bigPuffImage },
  { id: 'prefilled', title: 'PREFILLED POD KITS', image: prefilledPodKitsImage },
  { id: 'nic-salt', title: '10ML NIC SALT', image: nicSaltImage },
  { id: 'freebase', title: '10ML FREEBASE', image: freebaseImage },
  { id: 'shortfills', title: 'SHORTFILLS + NIC SHOTS', image: shortfillsImage },
  { id: 'pod-kits', title: 'POD KITS', image: podKitsImage },
  { id: 'pods', title: 'VAPE PODS', image: vapePodsImage },
  { id: 'kits', title: 'VAPE KITS', image: vapeKitsImage },
  { id: 'coils', title: 'COILS + TANKS', image: coilsTanksImage },
  { id: 'mods', title: 'VAPE MODS', image: vapeModsImage },
  { id: 'accessories', title: 'VAPE ACCESSORIES', image: accessoriesImage },
  { id: 'pos', title: 'POS', image: posImage },
];

function ShopByCategory() {
  return (
    <section className="shop-category" aria-label="Shop by category">
      <h2>Shop by category</h2>
      <div className="shop-category__grid">
        {categoryItems.map((item) => (
          <article key={item.id} className="shop-category__card">
            <div className="shop-category__image-wrap">
              <img src={item.image} alt={item.title} className="shop-category__image" />
            </div>
            <h3>{item.title}</h3>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ShopByCategory;
